<template>
  <v-dialog :value="open" :width="600" persistent scrollable>
    <v-card>
      <v-card-title>
        <div class="title flex">{{ $t('member_edit_history') }}</div>
        <v-btn icon left @click="$emit('update:open', false)">
          <v-icon>close</v-icon>
        </v-btn>
      </v-card-title>
      <v-card-text class="pa-0">
        <MemberEditHistoryDataTable v-if="dataTableRendered" :value="value" />
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import MemberEditHistoryDataTable from './MemberEditHistoryDataTable.vue'

export default {
  components: {
    MemberEditHistoryDataTable
  },
  model: {
    prop: 'open',
    event: 'update:open'
  },
  props: {
    value: {
      type: Object,
      default: undefined
    },
    open: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      dataTableRendered: false
    }
  },
  watch: {
    open(value) {
      if (value) {
        this.dataTableRendered = true
      } else {
        setTimeout(() => {
          this.dataTableRendered = false
        }, 300)
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/view/template/Juzmatch/MemberEditHistoryDialog.vue